import React from "react";
import {
    Button,
    Checkbox,
    FormControlLabel,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Tooltip,
    Typography,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { generatePDFHceAfiliado } from "../../../../actions/hce/hceActions";
import { LocalHospitalSharp } from "@material-ui/icons";

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

export const AfiliadoMenu = (props) => {

    const dispatch = useDispatch();

    const {
        afiliado = {},
    } = useSelector((state) => state.estudiosMedicos);

    const impresionHCE = () => {
        dispatch(generatePDFHceAfiliado(afiliado?.id_afiliado, null, true, false));
    }


    return (
        <React.Fragment>

            <Typography
                variant="h6"
                style={{
                    textDecoration: "underline",
                    textAlign: "center",
                    margin: "1.5rem 0",
                }}
            >
                Información Afiliado
                {
                    <Tooltip title="Historia Clínica">
                        <Button
                            style={{ marginTop: -5, marginLeft: 10 }}
                            onClick={() => impresionHCE()}
                        >
                            <LocalHospitalSharp fontSize="large" />
                        </Button>
                    </Tooltip>
                }
            </Typography>

            <Table style={{ width: "80%", margin: "auto" }}>
                <TableBody>
                    <TableRow>
                        <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                            Afiliado:
                        </TableCell>
                        <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                            {afiliado?.apellido_y_nombre}
                        </TableCell>
                        <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                            Email:
                        </TableCell>
                        <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                            {afiliado?.domiciliosAfiliados?.mail}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                            {afiliado ? "Cuil:" : "DNI:"}
                        </TableCell>
                        <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                            {afiliado?.cuil}
                        </TableCell>
                        <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                            Telefono:
                        </TableCell>
                        <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                            {afiliado?.domiciliosAfiliados?.telefono}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                            Fecha de Nac:
                        </TableCell>
                        <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                            {new Date(
                                afiliado?.fecha_nacimiento
                            ).toLocaleString("es", optionsfecha)}
                        </TableCell>
                        <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                            Celular:
                        </TableCell>
                        <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                            {afiliado?.domiciliosAfiliados?.celular}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <Grid
                style={{
                    marginTop: "1rem",
                    display: "flex",
                    justifyContent: "space-evenly",
                }}
            >
                <FormControlLabel
                    control={<Checkbox checked={afiliado?.incapacitado === 1} disabled />}
                    label={
                        <Typography style={{ color: "black" }}>Discapacitado</Typography>
                    }
                />
                <FormControlLabel
                    control={<Checkbox checked={afiliado?.judicializado === true} disabled />}
                    label={
                        <Typography style={{ color: "black" }}>Judicializado</Typography>
                    }
                />
            </Grid>
        </React.Fragment>
    )
}
